<template>
  <v-dialog :model-value="displayDialog" :persistent="true" width="auto">
    <v-card
      :width="isMobile ? 330 : 660"
      :height="isMobile ? 687 : 703"
      class="d-flex flex-column align-content-space-around"
    >
      <v-card-title class="d-flex justify-content-center">
        <h2
          class="text-wrap text-center"
          v-html="$t('plans.upgradePlanPopup.title')"
        ></h2>
        <v-btn
          :ripple="false"
          icon="mdi-close"
          variant="plain"
          @click="close"
          class="close-dialog"
        ></v-btn>
      </v-card-title>
      <v-card-subtitle class="d-flex justify-center justify-content-center">
        <p class="align-self-center">
          {{ $t("plans.upgradePlanPopup.subtitle") }}
        </p>
      </v-card-subtitle>
      <v-card-text class="d-flex align-self-center justify-center">
        <div
          class="mx-auto"
          :class="{
            'two-posters-one': displayedFrom === 'Live Section',
            'two-posters-two': displayedFrom !== 'Live Section',
          }"
        ></div>
      </v-card-text>
      <v-card-actions class="d-flex justify-content-center">
        <v-btn
          class="no-hover"
          :color="'#bd2130'"
          :ripple="false"
          @click="goToPlans"
          :to="{ name: 'plans-logged' }"
          variant="flat"
        >
          {{ $t("plans.upgradePlanPopup.okBtn") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import clevertap from "@/services/Clevertap";

const props = defineProps({
  displayDialog: Boolean,
  isMobile: Boolean,
  displayedFrom: {
    type: String,
    default: "Player",
  },
  backUrl: String,
});

const emit = defineEmits(["update:modelValue"]);

function close() {
  emit("update:modelValue", false);
  if (props.displayedFrom === "Player") {
    window.location.href = props.backUrl;
  }
}

function goToPlans() {
  emit("update:modelValue", false);
  clevertap.event.push("Up Convert Banner Button", {
    Platform: "Web",
    "Displayed From": props.displayedFrom,
  });
}
</script>

<style lang="scss" scoped>
.no-hover:hover :deep(.v-btn__overlay) {
  background-color: transparent;
  text-decoration: none !important;
  opacity: 1;
}
:deep(.v-card) {
  box-shadow: none;
  border: transparent none;
  box-sizing: unset;
}
.v-dialog > .v-overlay__content > .v-card {
  background: url("@/assets/img/plans/plan-upgrade-popup-bg.svg") no-repeat;
  background-size: cover;
  border-radius: 32px;
  .close-dialog {
    position: fixed;
    top: 6px;
    right: 26px;
    @media (max-width: 480px) {
      position: fixed;
      top: 0;
      right: 6px;
    }
  }
  .two-posters-one {
    background: url("/img/two-posters-7.svg") no-repeat;
    background-size: cover;
    width: 377px;
    height: 343px;
    @media (max-width: 480px) {
      width: 302px;
      height: 274px;
    }
  }
  .two-posters-two {
    background: url("/img/two-posters-6.svg") no-repeat;
    background-size: cover;
    width: 377px;
    height: 343px;
    @media (max-width: 480px) {
      width: 302px;
      height: 274px;
    }
  }
  .v-card-title {
    padding: 0;
    height: 100px;
    margin-top: 36px;
    h2 {
      font-size: 40px;
      line-height: 40px;
      width: 460px;
      height: 100px;
      white-space: break-spaces !important;
      @media (max-width: 480px) {
        width: 377px;
        margin-top: 26px;
        font-size: 28px;
        line-height: 28px;
      }
    }
  }
  .v-card-text {
    width: 472px;
    max-height: 380px;
    @media (max-width: 480px) {
      width: 402px;
      max-height: 343px;
    }
  }
  .v-card-subtitle {
    margin-top: 16px;
    p {
      width: 320px;
      height: 48px;
      white-space: break-spaces;
      text-align: center;
    }
  }
  .v-card-actions > .v-btn {
    font-size: 16px;
    text-transform: none;
    width: 377px;
    @media (max-width: 480px) {
      width: 302px;
      font-size: 12px;
      line-height: 12px;
    }
  }
}
</style>
